import angular from 'angular'

import TooltipComponent from './vd-tooltip.component'
import TooltipTriggerDirective from './vd-tooltip-trigger.directive'
import TooltipService from './vd-tooltip.service'

angular
  .module('vend.ui')
  .component('vdTooltip', TooltipComponent)
  .directive('vdTooltipTrigger', TooltipTriggerDirective)
  .service('vdTooltip', TooltipService)
